





















import { Component, Watch } from 'vue-property-decorator'
import Selector from '@/components/common/Selector.vue'

import Field from './Field.vue'

@Component({
  components: { Selector }
})
export default class FieldList extends Field {
  items = []
  selectedItem = null

  created() {
    for (const [index, value] of this.field.listValues.entries()) {
      this.items.push({ value, label: this.field.listLabels[index] })
    }
  }

  // Check if field is value or dropoffValue + if field is editable
  get currentItem() {
    return this.selectedItem || this.items.find((item) => {
      return item.value.toString() ===
      (this.isFirst
        ? this.field.value
        : (this.field.dropoff
          ? this.field.dropoffValue
          : this.field.value
        )
      )
    }) || { label: (this.isLocked ? this.field.value : null) }
  }

  updateCurrentItem(item) {
    this.selectedItem = item
    this.updateField(this.field, item.value.toString())
  }
}
